export default __webpack_public_path__ + "static/media/Sangeeta-Verma-1.dbd20bee.jpg";